import { render } from "./headMenu.vue?vue&type=template&id=db5a35ee&lang=html"
import script from "./headMenu.vue?vue&type=script&lang=js"
export * from "./headMenu.vue?vue&type=script&lang=js"

import "./headMenu.vue?vue&type=style&index=0&id=db5a35ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__